import type { AcademyOperatingProfileInput } from '../contracts/academyOnboarding';
import type { ClubOperatingProfileInput } from '../contracts/clubOnboarding';

/**
 * Combined org onboarding: club facilities share the academy's sport catalogue.
 * Copies academy sport selections into the club operating profile shape.
 */
export function clubSportsFromAcademyOperatingProfile(
  academyProfile: Partial<AcademyOperatingProfileInput>
): ClubOperatingProfileInput['sports'] | undefined {
  const sports = academyProfile.sports;
  if (!sports?.length) return undefined;

  return sports.map(({ sportId, customLabel, isPrimary }) => ({
    sportId,
    customLabel,
    isPrimary,
  }));
}

/** Combined org onboarding: reuse academy location count for club facility profile. */
export function clubLocationCountBandFromAcademyOperatingProfile(
  academyProfile: Partial<AcademyOperatingProfileInput>
): ClubOperatingProfileInput['locationCountBand'] | undefined {
  return academyProfile.locationCountBand ?? undefined;
}
